import _toConsumableArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classPrivateFieldInitSpec from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldSet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _classPrivateFieldGet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2017-2022 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Base } from '@polkadot/types-codec';
import { assert, compactAddLength, compactFromU8a, compactToU8a, isHex, isU8a, objectProperty, objectSpread, u8aConcat, u8aToHex, u8aToU8a } from '@polkadot/util';
import { BIT_SIGNED, BIT_UNSIGNED, DEFAULT_VERSION, UNMASK_VERSION } from "./constants.js";
var VERSIONS = ['ExtrinsicUnknown', // v0 is unknown
'ExtrinsicUnknown', 'ExtrinsicUnknown', 'ExtrinsicUnknown', 'ExtrinsicV4'];
export { EXTRINSIC_VERSION as LATEST_EXTRINSIC_VERSION } from "./v4/Extrinsic.js";
/** @internal */

function newFromValue(registry, value, version) {
  if (value instanceof GenericExtrinsic) {
    return value.unwrap();
  }

  var isSigned = (version & BIT_SIGNED) === BIT_SIGNED;
  var type = VERSIONS[version & UNMASK_VERSION] || VERSIONS[0]; // we cast here since the VERSION definition is incredibly broad - we don't have a
  // slice for "only add extrinsic types", and more string definitions become unwieldy

  return registry.createTypeUnsafe(type, [value, {
    isSigned: isSigned,
    version: version
  }]);
}
/** @internal */


function decodeExtrinsic(registry, value) {
  var version = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_VERSION;

  if (isU8a(value) || Array.isArray(value) || isHex(value)) {
    return decodeU8a(registry, u8aToU8a(value), version);
  } else if (value instanceof registry.createClassUnsafe('Call')) {
    return newFromValue(registry, {
      method: value
    }, version);
  }

  return newFromValue(registry, value, version);
}
/** @internal */


function decodeU8a(registry, value, version) {
  if (!value.length) {
    return newFromValue(registry, new Uint8Array(), version);
  }

  var _compactFromU8a = compactFromU8a(value),
      _compactFromU8a2 = _slicedToArray(_compactFromU8a, 2),
      offset = _compactFromU8a2[0],
      length = _compactFromU8a2[1];

  var total = offset + length.toNumber();
  assert(total <= value.length, function () {
    return "Extrinsic: length less than remainder, expected at least ".concat(total, ", found ").concat(value.length);
  });
  var data = value.subarray(offset, total);
  return newFromValue(registry, data.subarray(1), data[0]);
}

var ExtrinsicBase = /*#__PURE__*/function (_Base) {
  _inherits(ExtrinsicBase, _Base);

  var _super = _createSuper(ExtrinsicBase);

  function ExtrinsicBase(registry, value, initialU8aLength) {
    var _this;

    _classCallCheck(this, ExtrinsicBase);

    _this = _super.call(this, registry, value, initialU8aLength);
    var signKeys = Object.keys(registry.getSignedExtensionTypes());

    var getter = function getter(key) {
      return _this.inner.signature[key];
    }; // This is on the abstract class, ensuring that hasOwnProperty operates
    // correctly, i.e. it needs to be on the base class exposing it


    for (var i = 0; i < signKeys.length; i++) {
      objectProperty(_assertThisInitialized(_this), signKeys[i], getter);
    }

    return _this;
  }
  /**
   * @description The arguments passed to for the call, exposes args so it is compatible with [[Call]]
   */


  _createClass(ExtrinsicBase, [{
    key: "args",
    get: function get() {
      return this.method.args;
    }
    /**
     * @description The argument definitions, compatible with [[Call]]
     */

  }, {
    key: "argsDef",
    get: function get() {
      return this.method.argsDef;
    }
    /**
     * @description The actual `[sectionIndex, methodIndex]` as used in the Call
     */

  }, {
    key: "callIndex",
    get: function get() {
      return this.method.callIndex;
    }
    /**
     * @description The actual data for the Call
     */

  }, {
    key: "data",
    get: function get() {
      return this.method.data;
    }
    /**
     * @description The era for this extrinsic
     */

  }, {
    key: "era",
    get: function get() {
      return this.inner.signature.era;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */

  }, {
    key: "encodedLength",
    get: function get() {
      return this.toU8a().length;
    }
    /**
     * @description `true` id the extrinsic is signed
     */

  }, {
    key: "isSigned",
    get: function get() {
      return this.inner.signature.isSigned;
    }
    /**
     * @description The length of the actual data, excluding prefix
     */

  }, {
    key: "length",
    get: function get() {
      return this.toU8a(true).length;
    }
    /**
     * @description The [[FunctionMetadataLatest]] that describes the extrinsic
     */

  }, {
    key: "meta",
    get: function get() {
      return this.method.meta;
    }
    /**
     * @description The [[Call]] this extrinsic wraps
     */

  }, {
    key: "method",
    get: function get() {
      return this.inner.method;
    }
    /**
     * @description The nonce for this extrinsic
     */

  }, {
    key: "nonce",
    get: function get() {
      return this.inner.signature.nonce;
    }
  }, {
    key: "registry",
    get: function get() {
      return _get(_getPrototypeOf(ExtrinsicBase.prototype), "registry", this);
    }
    /**
     * @description The actual [[EcdsaSignature]], [[Ed25519Signature]] or [[Sr25519Signature]]
     */

  }, {
    key: "signature",
    get: function get() {
      return this.inner.signature.signature;
    }
    /**
     * @description The [[Address]] that signed
     */

  }, {
    key: "signer",
    get: function get() {
      return this.inner.signature.signer;
    }
    /**
     * @description Forwards compat
     */

  }, {
    key: "tip",
    get: function get() {
      return this.inner.signature.tip;
    }
    /**
     * @description Returns the raw transaction version (not flagged with signing information)
    */

  }, {
    key: "type",
    get: function get() {
      return this.inner.version;
    }
  }, {
    key: "inner",
    get: function get() {
      return this.unwrap();
    }
    /**
     * @description Returns the encoded version flag
    */

  }, {
    key: "version",
    get: function get() {
      return this.type | (this.isSigned ? BIT_SIGNED : BIT_UNSIGNED);
    }
    /**
     * @description Checks if the source matches this in type
     */

  }, {
    key: "is",
    value: function is(other) {
      return this.method.is(other);
    }
  }, {
    key: "unwrap",
    value: function unwrap() {
      return _get(_getPrototypeOf(ExtrinsicBase.prototype), "unwrap", this).call(this);
    }
  }]);

  return ExtrinsicBase;
}(Base);
/**
 * @name GenericExtrinsic
 * @description
 * Representation of an Extrinsic in the system. It contains the actual call,
 * (optional) signature and encodes with an actual length prefix
 *
 * {@link https://github.com/paritytech/wiki/blob/master/Extrinsic.md#the-extrinsic-format-for-node}.
 *
 * Can be:
 * - signed, to create a transaction
 * - left as is, to create an inherent
 */


var _hashCache = /*#__PURE__*/new WeakMap();

export var GenericExtrinsic = /*#__PURE__*/function (_ExtrinsicBase) {
  _inherits(GenericExtrinsic, _ExtrinsicBase);

  var _super2 = _createSuper(GenericExtrinsic);

  function GenericExtrinsic(registry, value) {
    var _this2;

    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        version = _ref.version;

    _classCallCheck(this, GenericExtrinsic);

    _this2 = _super2.call(this, registry, decodeExtrinsic(registry, value, version));

    _classPrivateFieldInitSpec(_assertThisInitialized(_this2), _hashCache, {
      writable: true,
      value: void 0
    });

    return _this2;
  }
  /**
   * @description returns a hash of the contents
   */


  _createClass(GenericExtrinsic, [{
    key: "hash",
    get: function get() {
      if (!_classPrivateFieldGet(this, _hashCache)) {
        _classPrivateFieldSet(this, _hashCache, _get(_getPrototypeOf(GenericExtrinsic.prototype), "hash", this));
      }

      return _classPrivateFieldGet(this, _hashCache);
    }
    /**
     * @description Injects an already-generated signature into the extrinsic
     */

  }, {
    key: "addSignature",
    value: function addSignature(signer, signature, payload) {
      this.inner.addSignature(signer, signature, payload);

      _classPrivateFieldSet(this, _hashCache, undefined);

      return this;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */

  }, {
    key: "inspect",
    value: function inspect() {
      var encoded = u8aConcat.apply(void 0, _toConsumableArray(this.toU8aInner()));
      return {
        inner: this.isSigned ? this.inner.inspect().inner : this.inner.method.inspect().inner,
        outer: [compactToU8a(encoded.length), new Uint8Array([this.version])]
      };
    }
    /**
     * @description Sign the extrinsic with a specific keypair
     */

  }, {
    key: "sign",
    value: function sign(account, options) {
      this.inner.sign(account, options);

      _classPrivateFieldSet(this, _hashCache, undefined);

      return this;
    }
    /**
     * @describe Adds a fake signature to the extrinsic
     */

  }, {
    key: "signFake",
    value: function signFake(signer, options) {
      this.inner.signFake(signer, options);

      _classPrivateFieldSet(this, _hashCache, undefined);

      return this;
    }
    /**
     * @description Returns a hex string representation of the value
     */

  }, {
    key: "toHex",
    value: function toHex(isBare) {
      return u8aToHex(this.toU8a(isBare));
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */

  }, {
    key: "toHuman",
    value: function toHuman(isExpanded) {
      return objectSpread({}, {
        isSigned: this.isSigned,
        method: this.method.toHuman(isExpanded)
      }, this.isSigned ? {
        era: this.era.toHuman(isExpanded),
        nonce: this.nonce.toHuman(isExpanded),
        signature: this.signature.toHex(),
        signer: this.signer.toHuman(isExpanded),
        tip: this.tip.toHuman(isExpanded)
      } : null);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.toHex();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      return 'Extrinsic';
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value is not length-prefixed
     */

  }, {
    key: "toU8a",
    value: function toU8a(isBare) {
      var encoded = u8aConcat.apply(void 0, _toConsumableArray(this.toU8aInner()));
      return isBare ? encoded : compactAddLength(encoded);
    }
  }, {
    key: "toU8aInner",
    value: function toU8aInner() {
      // we do not apply bare to the internal values, rather this only determines out length addition,
      // where we strip all lengths this creates an extrinsic that cannot be decoded
      return [new Uint8Array([this.version]), this.inner.toU8a()];
    }
  }]);

  return GenericExtrinsic;
}(ExtrinsicBase);